import React from "react";
import { FaArrowRight, FaClock, FaEye, FaSpinner, FaFileInvoice, FaReceipt, FaUsers } from "react-icons/fa";
import Popover from '../../Common/Popper';
import '../../Dashboard.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { AlarmClock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./VisitSummaryCard.css"

const VisitSummaryCard = ({
    selectedFilter,
    handleQuickSearch,
    ReportSerachTransactionsData,
    ReportSerachReportGenrateData,
    ReportDelayedData,
    showReportModal,
    setShowReportModal,
    formatVisitDate,
    onViewAllVisits,
    loader,
    startDate={startDate},
    endDate={endDate},
    dateRangeOption={dateRangeOption}
}) => {

    const navigate = useNavigate();
    
    const handleNavigateToPatientVisitWithDateRange = () => {
    let navStartDate = startDate;
    let navEndDate = endDate;
    let navDateRangeOption = dateRangeOption;

    if (selectedFilter === "2d") {
        // Calculate yesterday and today
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        navStartDate = yesterday.toISOString().slice(0, 10);
        navEndDate = today.toISOString().slice(0, 10);
        navDateRangeOption = "Custom";
    }

    navigate("/patientvisit", {
        state: {
            startDate: navStartDate,
            endDate: navEndDate,
            dateRangeOption: navDateRangeOption,
            filter: "AVAILABLE"
        }
    });
};

    const handleNavigateToPatientVisit = () =>{
        navigate("/patientvisit")
    }

    return (
        <div className="col-md-6 col-lg-4">
            <div className="bg-white dashboard-card dashboard-card-enhanced rounded shadow-sm p-3 h-100">
                <div className="d-flex flex-column flex-xl-row justify-content-between align-items-xl-center mb-3">
                    <h5 className="mb-0">Visit Summary</h5>
                    <div className="btn-group mt-2 mt-xl-0 align-self-center">
                        <div className="d-flex gap-2">
                            <button className={`btn report-search-btn btn-sm ${selectedFilter === "Today" ? "active" : ""}`} style={{ border: "none" }} onClick={() => handleQuickSearch("Today")}>Today</button>
                            <button className={`btn report-search-btn btn-sm ${selectedFilter === "2d" ? "active" : ""}`} style={{ border: "none" }} onClick={() => handleQuickSearch("2d")}>2d</button>
                            <button className={`btn report-search-btn
                                 btn-sm ${selectedFilter === "Last 7 Days" ? "active" : ""}`} style={{ border: "none" }} onClick={() => handleQuickSearch("Last 7 Days")}>7d</button>
                            {/* <button className={`btn report-search-btn btn-sm ${selectedFilter === "15d" ? "active" : ""}`} style={{ border: "none" }} onClick={() => handleQuickSearch("15d")}>15d</button>
                            <button className={`btn report-search-btn btn-sm ${selectedFilter === "MTD" ? "active" : ""}`} style={{ border: "none" }} onClick={() => handleQuickSearch("MTD")}>MTD</button> */}
                        </div>

                    </div>
                </div>

                {loader ? (
                    <div className="centered-message-loader" style={{ padding: "30px 0" }}>
                        <FaSpinner
                            style={{ width: "50px", height: "50px", color: "green" }}
                            className="fa-spin text-dark-500"
                        />
                    </div>
                ) : (
                    <>
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-1 row-cols-xl-2 g-2 mb-2">
                            <div className="col">
                                {/* <div onClick={handleNavigateToPatientVisit} className="h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center visit-summary-border" style={{ minHeight: '75px', cursor: "pointer" }}> */}
                                <div onClick={onViewAllVisits} className="h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center visit-summary-border" style={{ minHeight: '75px', cursor: "pointer" }}>
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        <FaUsers style={{ fontSize: '1.2rem', color: "#01994e", }} />
                                        <div className="fs-6 fw-semibold">{ReportSerachTransactionsData || 0}</div>
                                    </div>
                                    <small className="text-muted">Patient Visits</small>
                                </div>
                            </div>
                            <div className="col">
                                <div onClick={handleNavigateToPatientVisitWithDateRange} className="cursor-pointer h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center visit-summary-border" style={{ minHeight: '75px', cursor: "pointer"}}>
                                {/* <div onClick={onViewAllVisits} className="cursor-pointer h-100 text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center visit-summary-border" style={{ minHeight: '75px', cursor: "pointer"}}> */}
                                    <div className="d-flex gap-2 align-items-center">
                                        <FaFileInvoice style={{
                                            fontSize: "1rem",
                                            color: "#01994e",
                                        }} />
                                        <div className="fs-6 fw-semibold">{ReportSerachReportGenrateData || 0}</div>
                                    </div>
                                    <small className="text-muted">Reports Available</small>
                                </div>
                            </div>
                        </div>

                        <div className="row row-cols-1 g-2 mb-3">
                            <div className="col">
                                <div className="border rounded text-center p-2 h-100 position-relative d-flex  justify-content-center gap-2 align-items-center">
                                    {/* Eye icon in top-right corner */}
                                    <div className="fs-6 fw-semibold text-muted">
                                        {ReportDelayedData?.length > 0 ? (
                                            <>
                                                <FaEye
                                                    className="position-absolute"
                                                    style={{
                                                        top: "10px",
                                                        right: "12px",
                                                        cursor: "pointer",
                                                        fontSize: "1.2rem",
                                                        color: "#00984A",
                                                    }}
                                                    title="View Details"
                                                    onClick={() => setShowReportModal(true)}
                                                />

                                                {/* Center-aligned text */}
                                                <div className="d-flex align-items-center">
                                                    <AlarmClock
                                                        className="vibrate mr-1"
                                                        stroke="red"
                                                        size={18}
                                                    />
                                                    <small className="text-muted">Report Delayed:</small>&nbsp;
                                                    {ReportDelayedData.length}
                                                </div>
                                            </>
                                        ) : (
                                            "No delayed records found"
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="text-end">
                            <button
                                className="btn btn-link custom-cardview-visit-summary fw-bold small p-0"
                                style={{ color: "#00984A", fontSize: "12px", textDecoration: "underline" }}
                                onClick={onViewAllVisits}
                            >
                                View All Visits <FaArrowRight className="ms-1" style={{ fontSize: "12px" }} />
                            </button>

                        </div>

                        {showReportModal && (
                            <div className="modal-backdrop">
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-lg custom-modal" role="document" >
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Report Delayed Records</h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setShowReportModal(false)}
                                                ></button>
                                            </div>
                                            <div className="modal-body p-2 mb-1">
                                                <div className="table-responsive" style={{ overflowX: "hidden" }} >
                                                    <table className="table table-bordered custom-table" >
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: "15%" }}>Patient Name</th>
                                                                <th style={{ width: "15%" }}>VID</th>
                                                                <th style={{ width: "15%" }}>VID Date</th>
                                                                <th style={{ width: "10%" }}>Status</th>
                                                                <th style={{ width: "25%" }}>Test Name</th>
                                                                <th style={{ width: "15%" }}>TAT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {ReportDelayedData?.map((rec, idx) => (
                                                                <tr key={idx}>
                                                                    <td>{rec.MHL_Patient_Name}</td>
                                                                    <td>{rec.Name}</td>
                                                                    <td>{formatVisitDate(rec.MHL_Visit_Date__c)}</td>
                                                                    <td>{rec.MHL_Visit_Status__c}</td>
                                                                    <td>
                                                                        {rec.MHL_Test_Details_List.length === 1 && (
                                                                            <>
                                                                                {rec.MHL_Test_Details_List[0].MHL_TestName__c.length > 30 ? (
                                                                                    <Popover
                                                                                        content={
                                                                                            <span>{rec.MHL_Test_Details_List[0].MHL_TestName__c}</span>
                                                                                        }
                                                                                    >
                                                                                        <span style={{ cursor: 'pointer' }}>
                                                                                            {rec.MHL_Test_Details_List[0].MHL_TestName__c.substring(0, 30)}...
                                                                                        </span>
                                                                                    </Popover>
                                                                                ) : (
                                                                                    rec.MHL_Test_Details_List[0].MHL_TestName__c
                                                                                )}
                                                                            </>
                                                                        )}

                                                                        {rec.MHL_Test_Details_List?.length > 1 && (
                                                                            <Popover
                                                                                content={
                                                                                    <ul
                                                                                        className="list-unstyled"
                                                                                        style={{ textAlign: 'left', paddingLeft: '1rem', margin: 0 }}
                                                                                    >
                                                                                        {rec.MHL_Test_Details_List.map((test, index) => (
                                                                                            <li key={index}>{test.MHL_TestName__c}</li>
                                                                                        ))}
                                                                                    </ul>
                                                                                }
                                                                            >
                                                                                <span style={{ marginLeft: '5px', cursor: 'pointer' }}>
                                                                                    {rec.MHL_Test_Details_List[0].MHL_TestName__c.length > 30
                                                                                        ? `${rec.MHL_Test_Details_List[0].MHL_TestName__c.substring(0, 30)}...`
                                                                                        : rec.MHL_Test_Details_List[0].MHL_TestName__c}
                                                                                    {` (+${rec.MHL_Test_Details_List.length - 1})`}
                                                                                </span>
                                                                            </Popover>
                                                                        )}
                                                                    </td>
                                                                    <td>{rec.MHL_Test_TAT_Date || "-"}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => setShowReportModal(false)}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </>
                )}
            </div>
        </div>
    );
};

export default VisitSummaryCard;
